import { Component, Inject } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DialogRef } from '../../aero/aero-dialog/types';

/**
 * Component for joining a group via token input.
 * Provides a dialog interface for users to enter a group token to join a group.
 * Manages the dialog's primary button state based on token validity.
 */
@Component({
  selector: 'bulb-join-group',
  templateUrl: './join-group.component.html',
  standalone: false,
})
export class JoinGroupComponent {
  groupToken = '';

  /**
   * Creates a new instance of the component with injected dialog dependencies.
   * @param dialogRef The reference to the dialog, used to control dialog behavior and communication
   * @param config The configuration object for the dynamic dialog, containing dialog settings and data
   * @return Initializes the component with the provided dialog reference and configuration
   */
  constructor(@Inject('DialogRef') private dialogRef: DialogRef, public config: DynamicDialogConfig) {
    this.dialogRef.setPrimaryDisabled(true);
  }

  /**
   * Handles the change event for the group token.
   * Updates the dialog primary button disabled state based on the group token value
   * and notifies the config data of the value change.
   *
   * @return {void}
   */
  changed(): void {
    this.dialogRef.setPrimaryDisabled(!this.groupToken);
    this.config.data.valueChange(this.groupToken);
  }
}
